import { DataSource, HorizontalSpacer, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutBillingFreightItemTable extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelHandlingUnitsCaption: Label;
    labelTotalUnits: Label;
    labelTotalWeight: Label;
    labelWeightCaption: Label;
    panelFrightInfo: Panel;
    sourceBillingFreightGroup: DataSource;
    tableFreightItems: Table;
}
